<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div [config]="preloaderService.getLoadingConfig(loaderKey)" [suiIsLoading]="loaderKey" class="preloader-wrapper">
    @if (isIdentified) {
        <div class="dialog-form">
            <div class="siklu-mat-dialog-title" matDialogTitle>
                <h4>Report problem</h4>
                <button matDialogClose windeClose>
                    <sui-svg-icon icon="cross"/>
                </button>
            </div>

            <winde-alert-error></winde-alert-error>

            @if (isSuccessfulAlert) {
                <div class="alert alert-success">
                    <span>
                        The bug report is successfully registered.
                        <br>
                        We're on it and will work to fix this soon.
                        <br>
                        We appreciate you helping us improve the WiNDE.
                    </span>
                </div>
            }
            <div class="siklu-mat-dialog-body" matDialogContent>
                @if (!isSuccessfulAlert) {
                    <div class="form-group">
                        <label for="report-problem-title">Report title *</label>
                        <input
                                [(ngModel)]="reportProblem.title"
                                class="form-control"
                                id="report-problem-title"
                                maxlength="255"
                                name="report-problem-title"
                                type="text"
                                required
                        />
                    </div>
                    <div class="form-group">
                        <label for="report-problem-description">Report description</label>
                        <textarea
                                [(ngModel)]="reportProblem.description"
                                class="form-control"
                                id="report-problem-description"
                                name="report-problem-description"
                                rows="5"
                        >
                        </textarea>
                    </div>
                    <div class="multiple-files">
                        <ul class="multiple-files__list">
                            <li *ngFor="let file of attachedFiles" class="multiple-files__item">
                                {{ file.name }}
                                <button (click)="removeFileFromList(file)" class="multiple-files__remove-item" windeActionIcon>
                                    <sui-svg-icon icon="cross" windeRed/>
                                </button>
                            </li>
                        </ul>
                        <label class="btn btn-sm btn-add-file" for="file-upload">Select files</label>
                        <input (change)="changeFiles($event)" class="d-none" id="file-upload" multiple name="file-upload" type="file"/>
                    </div>
                }
            </div>

            <div class="siklu-mat-dialog-footer" matDialogActions>
                @if (!isSuccessfulAlert) {
                    <button (click)="sendReport()" type="submit" [disabled]="!reportProblem.title" windeGreen>
                        <sui-svg-icon icon="envelope"/>
                        Send
                    </button>
                }
            </div>
        </div>
    }
</div>
